import React from 'react';
import parse from 'html-react-parser';

type Props = {
    text: string;
};

export default function MTaskTitle({ text }: Props) {
    return (
        <React.Fragment>
            <div className="task-title">
                <div className="task-title-text">{parse(text)}</div>
            </div>
        </React.Fragment>
    );
}
